module.exports = __webpack_public_path__ + "static/media/GoogleSans-MediumItalic.c013732c.woff2";